import { getHeaders } from "../utils/HeaderHelper";

export type DiagnosisOption = [code: string, description: string];


export const fetchDiagnosisOptions = async (
  term: string,
  csrfToken: string
): Promise<DiagnosisOption[]> => {
  if (!term.trim()) return [];

  const response = await fetch(
    `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${encodeURIComponent(
      term
    )}`,
    {
      method: "GET",
      headers: getHeaders(csrfToken),
    }
  );

  const result = await response.json();

  return (result[3] ?? []) as DiagnosisOption[];
};